import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { TabViewItem } from '@interfaces/a-organizar/tabViewItem';
import { SharedModule } from '@shared/shared.module';
import { PartnerIncomeTaxSectionKey } from '@features/dashboard/performance/pages/dfp/components/partner-income-tax/partner-income-tax-section.state';

/** Uma aba interna: chave do `?section=`, título e contador opcional ("Bens e direitos (21)"). */
export interface SectionTab {
  key: PartnerIncomeTaxSectionKey;
  title: string;
  count?: number;
}

/**
 * Aba "Documentos (n)": com documento não lido ou com erro, o título ganha "· n a ler" (o ponto de atenção da aba).
 */
export function documentsTab(total: number, pending: number): SectionTab {
  return {
    key: 'documents',
    title: pending ? `Documentos · ${pending} a ler` : 'Documentos',
    count: total || undefined,
  };
}

/**
 * Abas internas sublinhadas da aba IR dos sócios (protótipo 01): mesmo `app-tab-view` tema `line` das abas da DFP,
 * com o contador do wrapper.
 */
@Component({
  selector: 'app-pit-section-tabs',
  standalone: true,
  imports: [SharedModule],
  template: `
    <app-tab-view
      class="section-tabs"
      theme="line"
      [tabViewItems]="items()"
      [tabIndex]="activeIndex()"
      (sendTabViewActiveIndex)="onSelect($event)" />
  `,
  styleUrl: './section-tabs.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionTabsComponent {
  readonly tabs = input.required<SectionTab[]>();
  readonly active = input.required<PartnerIncomeTaxSectionKey>();
  readonly selectSection = output<PartnerIncomeTaxSectionKey>();

  protected readonly items = computed<TabViewItem[]>(() =>
    this.tabs().map((tab, index) => ({
      title: tab.title,
      count: tab.count,
      tabindex: index,
      content: '',
      id: tab.key,
    }))
  );

  protected readonly activeIndex = computed(() =>
    Math.max(
      0,
      this.tabs().findIndex(tab => tab.key === this.active())
    )
  );

  protected onSelect(index: number): void {
    const tab = this.tabs()[index];
    if (tab && tab.key !== this.active()) this.selectSection.emit(tab.key);
  }
}
